import React from "react";
import { showCookiePreferencesModal } from "@/app/utils/cookieConsent";
import styles from "@/styles/CookiePreferencesButton.module.scss";

type CookiePreferencesButtonProps = {
	className?: string;
	children?: React.ReactNode;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const CookiePreferencesButton: React.FC<
	CookiePreferencesButtonProps
> = ({
	className,
	children = "Mostrar preferências de cookie",
	onClick,
}) => (
	<button
		type="button"
		data-cc="show-preferencesModal"
		aria-haspopup="dialog"
		className={className ? `${styles.button} ${className}` : styles.button}
		onClick={(event) => {
			showCookiePreferencesModal();
			onClick?.(event);
		}}
	>
		{children}
	</button>
);
